import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  button: {
    display: 'block',
    borderRadius: 0,
    height: 'auto',
    padding: theme.spacing(0, 2),
    fontSize: 24,
    fontWeight: 400,
    ...reskinStyles(theme, {
      position: 'relative',
      '& [class*="MuiButton-label"]::after': { display: 'none' },
      borderLeft: '4px solid transparent',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: -4,
        top: 6,
        bottom: 6,
        width: 4,
        backgroundColor: theme.colors.button__background_secondary,
        transform: 'scaleY(0)',
        transformOrigin: 'top',
        transition: 'transform var(--motion-duration-feedback, 0ms) var(--motion-ease-out, ease-out)'
      },
      '&[aria-current="page"]::before': { transform: 'scaleY(1)' },
      '&[aria-current="page"]': { borderLeftColor: 'transparent' },
      '@media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)': {
        ':root[data-motion="on"][data-input="pointer"] &:hover::before': { transform: 'scaleY(1)' }
      }
    })
  },
  selected: {
    borderLeft: `4px solid ${theme.colors.button__background_secondary}`,
    fontWeight: 600
  }
});

export default makeStyles(styles);
